import React, { useEffect, useState } from 'react';
import { FolderPlus, Loader2, Sparkles } from 'lucide-react';
import { apiService } from '../../services/api';

// Réunion sans projet où un nouveau projet a été discuté : Muse propose de le créer (en proposition, dont on est
// responsable). La réunion y est alors rattachée : sa synthèse rejoint le journal, ses actions deviennent des objectifs.
const NewProjectProposal = ({ meeting, onChange }) => {
  const proposal = meeting.summary_data?.new_project;
  const [name, setName] = useState(proposal?.name || '');
  const [clientId, setClientId] = useState(proposal?.client_id || '');
  const [brief, setBrief] = useState(proposal?.brief || '');
  const [clients, setClients] = useState([]);
  const [saving, setSaving] = useState(null); // 'create' | 'dismiss'
  const [error, setError] = useState(null);

  const pending = Boolean(proposal && !meeting.project_id && !proposal.dismissed && !proposal.created_project_id);
  useEffect(() => {
    if (pending) apiService.get('/clients').then((rows) => setClients(rows || [])).catch(() => setClients([]));
  }, [pending]);
  if (!pending) return null;

  const act = async (kind) => {
    setSaving(kind);
    setError(null);
    try {
      onChange(kind === 'create'
        ? await apiService.post(`/meetings/${meeting.id}/project`, { name: name.trim(), client_id: clientId ? Number(clientId) : null, brief: brief.trim() || null })
        : await apiService.post(`/meetings/${meeting.id}/project/dismiss`, {}));
    } catch (err) {
      setError(err.message);
      setSaving(null);
    }
  };

  return (
    <div className="rounded-xl border border-violet-200 bg-violet-50/50 p-3">
      <p className="flex items-center gap-1.5 text-sm font-semibold text-violet-900">
        <Sparkles className="h-4 w-4 text-violet-500" /> Un nouveau projet a été évoqué : le créer ?
      </p>
      <p className="mt-0.5 text-xs text-violet-800/80">
        Créé en proposition, avec toi comme responsable ; la réunion y sera rattachée (journal, actions à valider).
      </p>
      <div className="mt-2 grid gap-2 sm:grid-cols-2">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nom du projet" maxLength={120}
          className="rounded-lg border border-violet-200 bg-white px-2.5 py-1.5 text-sm outline-none focus:border-violet-400" />
        <select value={clientId} onChange={(e) => setClientId(e.target.value)}
          className="rounded-lg border border-violet-200 bg-white px-2.5 py-1.5 text-sm outline-none focus:border-violet-400">
          <option value="">{proposal.client && !proposal.client_id ? `Client : « ${proposal.client} » (à choisir)` : 'Sans client'}</option>
          {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>
      <textarea value={brief} onChange={(e) => setBrief(e.target.value)} rows={2} placeholder="Brief" maxLength={1000}
        className="mt-2 w-full rounded-lg border border-violet-200 bg-white px-2.5 py-1.5 text-sm outline-none focus:border-violet-400" />
      {error && <p className="mt-1 text-xs text-rose-600">{error}</p>}
      <div className="mt-2 flex flex-wrap items-center gap-2">
        <button type="button" onClick={() => act('create')} disabled={!name.trim() || saving}
          className="flex items-center gap-1.5 rounded-lg bg-violet-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-violet-700 disabled:opacity-50">
          {saving === 'create' ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FolderPlus className="h-3.5 w-3.5" />} Créer le projet
        </button>
        <button type="button" onClick={() => act('dismiss')} disabled={Boolean(saving)}
          className="rounded-lg px-3 py-1.5 text-xs font-medium text-violet-700 hover:bg-violet-100">Ce n'est pas un projet</button>
      </div>
    </div>
  );
};

export default NewProjectProposal;
